import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import WhatsAppIcon from "./WhatsAppIcon";
import { companyInfo } from "../data/mock";

const ContactCTA = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1200px] mx-auto px-6">
        <div
          className="relative rounded-[2rem] overflow-hidden p-12 md:p-20"
          style={{
            background:
              "linear-gradient(135deg, #0a2e1f 0%, #0f5132 50%, #047857 100%)",
          }}
        >
          {/* Decorative blobs */}
          <div
            className="absolute -top-20 -left-20 w-80 h-80 rounded-full blur-3xl opacity-30 pointer-events-none"
            style={{
              background:
                "radial-gradient(circle, #34d399 0%, transparent 70%)",
            }}
          />
          <div
            className="absolute -bottom-20 -right-20 w-96 h-96 rounded-full blur-3xl opacity-25 pointer-events-none"
            style={{
              background:
                "radial-gradient(circle, #6ee7b7 0%, transparent 70%)",
            }}
          />
          {/* Pattern */}
          <div
            className="absolute inset-0 opacity-[0.07] pointer-events-none"
            style={{
              backgroundImage:
                "radial-gradient(circle at 25% 25%, rgba(255,255,255,0.4) 1px, transparent 1px), radial-gradient(circle at 75% 75%, rgba(255,255,255,0.3) 1px, transparent 1px)",
              backgroundSize: "40px 40px",
            }}
          />

          <div className="relative z-10 text-center">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-5 tracking-tight">
              Ready to start your project?
            </h2>
            <p className="text-emerald-100/90 text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
              Get in touch with our team for Military, Commercial, Industrial
              Electronic & Electrical Wire & Cable services across Hawaii.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-white text-emerald-800 text-sm font-semibold rounded-full shadow-xl hover:scale-[1.03] transition-transform"
              >
                Contact Us <ArrowRight size={16} />
              </Link>
              <a
                href={companyInfo.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-8 py-3.5 text-white text-sm font-semibold rounded-full border border-white/30 hover:bg-white/10 backdrop-blur-sm transition-colors"
              >
                <WhatsAppIcon size={16} /> WhatsApp Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;
